import { AddClueResponse, getClueDetail } from '@/services/clue';
import { MemberStatus } from '@/types/member';
import { PaymentType } from '@/types/common';
import { ActivationMode } from '@/types/member';
import { QuickOpenCardStepKey } from '@/types/member';

function sleep(ms: number) {
  return new Promise<void>((resolve) => {
    setTimeout(() => resolve(), ms);
  });
}

export function extractLeadIdFromResponse(res: AddClueResponse): number | undefined {
  if (typeof res.lead_id === 'number' && res.lead_id > 0) {
    return res.lead_id;
  }
  const firstItem = res.list?.[0];
  if (!firstItem) {
    return undefined;
  }
  if (typeof firstItem.lead_id === 'number' && firstItem.lead_id > 0) {
    return firstItem.lead_id;
  }
  if (typeof firstItem.id === 'number' && firstItem.id > 0) {
    return firstItem.id;
  }
  return undefined;
}

export async function waitForClueUserId(leadId: number): Promise<number> {
  const maxAttempts = 12;
  const intervalMs = 500;

  for (let i = 0; i < maxAttempts; i++) {
    if (i > 0) {
      await sleep(intervalMs);
    }
    const detail = await getClueDetail({ lead_id: leadId });
    if (detail?.user_id > 0) {
      return detail.user_id;
    }
  }

  throw new Error('用户生成超时，请稍后重试');
}

export function getMemberStatusLabel(isMember: MemberStatus): {
  text: string;
  color: 'success' | 'warning' | 'default';
} {
  if (isMember === MemberStatus.VALID) {
    return { text: '有效会员', color: 'success' };
  }
  if (isMember === MemberStatus.INVALID) {
    return { text: '无效会员', color: 'default' };
  }
  return { text: '未开卡', color: 'warning' };
}

export function getPaymentTypeLabel(paymentType?: PaymentType): string {
  if (paymentType === PaymentType.TIMES) {
    return '次卡';
  }
  if (paymentType === PaymentType.DAY) {
    return '期限卡';
  }
  return '-';
}

export function getActivateTypeLabel(activateType: ActivationMode): string {
  if (activateType === ActivationMode.IMMEDIATELY) {
    return '办卡后立即激活';
  }
  return '首次签到激活';
}

export function getStepPath(flowPath: 'existingUser' | 'newClue'): QuickOpenCardStepKey[] {
  if (flowPath === 'newClue') {
    return ['search', 'clue', 'openCard', 'complete'];
  }
  return ['search', 'openCard', 'complete'];
}
